/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import cn from 'clsx';
import { AModal, AButton, AInput } from 'components/Antd';
import T from 'i18n-react';
import classes from './RenameModal.module.scss';

const RenameModal = ({ open, onClose, onSubmit, defaultSelectedDocument }) => {
  const tDefaultName = defaultSelectedDocument?.name;
  const [val, setVal] = useState(
    (typeof tDefaultName === 'string' ? tDefaultName : defaultSelectedDocument?.folderName) || ''
  );

  return (
    <AModal
      title="Rename Document"
      open={open}
      onCancel={onClose}
      closable
      width={480}
      className={cn(classes.modalWrapper)}>
      <div className={classes.content}>
        <AInput
          placeholder="Fill"
          value={val}
          onChange={(e) => {
            setVal(e.target.value);
          }}
          radius="md"
          size="large"
          minHeight
        />
      </div>
      <div className={classes.footer}>
        <AButton
          htmlType="button"
          type="primary"
          size="large"
          disabled={!(val || '').trim()}
          onClick={() => {
            if (!!onSubmit && !!(val || '').trim()) {
              onSubmit(val.trim());
            }
          }}
          className={classes.confirmBtn}>
          Confirm
        </AButton>
      </div>
    </AModal>
  );
};

export default RenameModal;
